export default "__VITE_ASSET__Cas_IiKs__"